"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reactive_vue_1 = require("@formily/reactive-vue");
var vue_1 = require("@formily/vue");
var vue_demi_1 = require("vue-demi");
// @ts-ignore
var Location_vue_1 = __importDefault(require("./Location.vue"));
var formilyLocation = (0, reactive_vue_1.observer)((0, vue_demi_1.defineComponent)({
    name: 'Location',
    props: ['value'],
    setup: function (curProps, _a) {
        var attrs = _a.attrs, emit = _a.emit;
        // const field = useField();
        var form = (0, vue_1.useForm)();
        return function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            return (0, vue_1.h)(Location_vue_1.default, {
                attrs: __assign(__assign(__assign({}, curProps), attrs), { username: (_c = (_b = (_a = form.value) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b.$context) === null || _c === void 0 ? void 0 : _c.user, ticketId: (_f = (_e = (_d = form.value) === null || _d === void 0 ? void 0 : _d.values) === null || _e === void 0 ? void 0 : _e.$context) === null || _f === void 0 ? void 0 : _f.ticketId, taskId: (_j = (_h = (_g = form.value) === null || _g === void 0 ? void 0 : _g.values) === null || _h === void 0 ? void 0 : _h.$context) === null || _j === void 0 ? void 0 : _j.taskId }),
                on: {
                    change: function (val) {
                        emit('change', val);
                    },
                },
            }, {
                default: function () { return [curProps.value || attrs.content]; },
            });
        };
    },
}));
exports.default = formilyLocation;
